import {useEffect, useRef, useCallback} from 'react';
import {throttle} from 'lodash-es';

import eventBus, {SIDEBAR_WIDTH_CHANGE} from '@/eventBus';

import * as store from '@/store';

interface IProps {}

const Name: React.FC<IProps> = () => {
    const targetRef = useRef<HTMLDivElement | null>(null);

    const onChange = useCallback(() => {
        const rect = targetRef.current?.getBoundingClientRect();
        if (rect) {
            store.setDocContentWidth({width: rect.width, left: rect.left || rect.x});
        }
    }, []);

    useEffect(() => {
        let resizeObserver: ResizeObserver | null = null;
        if (window.ResizeObserver && targetRef.current) {
            resizeObserver = new window.ResizeObserver(throttle(onChange, 100));

            resizeObserver.observe(targetRef.current);
        }

        return () => {
            resizeObserver && resizeObserver.disconnect();
        };
    }, [onChange]);

    useEffect(() => {
        // 延时是为了保证在文档内容、划线评论渲染完成后执行，目前没有编辑器没有提供合适的事件来触发
        setTimeout(onChange, 1000);

        window.addEventListener('resize', onChange);
        eventBus.on(SIDEBAR_WIDTH_CHANGE, onChange);

        return () => {
            window.removeEventListener('resize', onChange);
            eventBus.off(SIDEBAR_WIDTH_CHANGE, onChange);
        };
    }, [onChange]);

    return <div ref={targetRef}></div>;
};

export default Name;
